import type { ComponentPropsWithRef } from 'react'
import { useId } from 'react'

export interface TextInputProps extends Omit<
    ComponentPropsWithRef<'input'>,
    'value' | 'defaultValue'
> {
    defaultValue?: string | number | readonly string[] | null
    prefix?: string
    useBookingFormThemeCssVariables?: boolean
}

export function TextInput({
    defaultValue,
    prefix,
    useBookingFormThemeCssVariables = false,
    id,
    name,
    className = '',
    ref,
    ...inputProps
}: TextInputProps) {
    const generatedId = useId()
    const inputId = id ?? (name ? name : generatedId)

    const focusClassName = useBookingFormThemeCssVariables
        ? 'focus:ring-booking-form-theme-main-background-color focus:border-booking-form-theme-main-background-color'
        : 'focus:ring-primary focus:border-primary'

    const roundedClassName = prefix ? 'rounded-r-lg2' : 'rounded-lg2'

    return (
        <div className="flex items-center w-full">
            {prefix && (
                <div
                    aria-hidden="true"
                    className="bg-stone-100 px-3 py-2 shadow-xs border-l border-y border-stone-200 rounded-l-lg2 text-gray-600 whitespace-nowrap select-none"
                >
                    {prefix}
                </div>
            )}
            <input
                {...inputProps}
                ref={ref}
                id={inputId}
                name={name}
                defaultValue={defaultValue ?? undefined}
                className={`bg-white px-3 py-2 shadow-xs border border-stone-200 placeholder-gray-300 w-full disabled:bg-stone-100 disabled:text-gray-500 disabled:select-none disabled:cursor-not-allowed focus:outline-none focus:ring-1 ${focusClassName} ${roundedClassName} ${className}`.trim()}
            />
        </div>
    )
}
